module.exports = __webpack_public_path__ + "static/drupal-f6a3f1b9b0d4b7502485124eab9a9c8b.svg";